import { render, staticRenderFns } from "./templateName.vue?vue&type=template&id=7823e3be&scoped=true"
import script from "./templateName.vue?vue&type=script&lang=js"
export * from "./templateName.vue?vue&type=script&lang=js"
import style0 from "./templateName.vue?vue&type=style&index=0&id=7823e3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823e3be",
  null
  
)

export default component.exports